import React from 'react';
import axios from "axios";
import configData from "../../config/config.json";
import { connect } from "react-redux";
import { Form, Container, Row, Button, Col } from 'react-bootstrap'

import PageBanner from "../common/page/PageBanner.js";

import PrimaryButton from "../common/form/PrimaryButton.js";

import TextField from "../common/form/TextField.js";

import Alert from '../common/modal/Alert';
import AlertEntryEmailRow from './AlertEntryEmailRow.js'
import { setSelectedControlPanelType, AlertListControlPanelKey } from "../../redux/actions/controlPanelActions";
import { saveTenantAlert } from "../../redux/actions/alertActions";
import Loading from '../common/modal/Loading';
import { formatPhone } from "../common/function/formattingUtils.js";
import { ALERT_TYPES, LOADING_STATUES } from "../../components/constants/constants";
import { trimAlertFields, validateAlert } from "../common/function/alertValidation.js";
import EmailAddressSelectionList from '../common/selection/EmailAddressSelectionList';
import PhoneNumberSelectionList from '../common/selection/PhoneNumberSelectionList';
import { checkIconGreen, spinnerIconGray } from "../../img/font_awesome/font_awesome"
import AlertEntryPhoneRow from './AlertEntryPhoneRow.js';
import Confirmation from '../common/modal/Confirmation';

const componentName = AlertListControlPanelKey; //TODO

const mapStateToProps = (state) => {
	return {
		sideNavigationOpen: state.sideNavigationReducer,
		alertListFilters: state.alertListFiltersReducer,
		alertSettings: state.countyConfigAlertSettingsReducer,
		multiTenantSettings: state.countyConfigMultiTenantSettingsReducer
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName)),
		saveTenantAlert: (alert, callback) => dispatch(saveTenantAlert(alert, callback))
	}
}

class AlertEntry extends React.Component {
	state = {
		id: 0,
		userId: null,
		savedUserId: null,
		username: '',
		countyList: [{'NONE': ''}],
		countyCode: null,
		
		alertType: 'BUSINESS',
		name: '',
		firstName: '',
		lastName: '',
		businessName: '',

		alertEmailAddresses: [],
		alertPhones: [],

		parcelId: '',
		selectedEmailField: '',
		selectedPhoneField: '',
		statusType: 'A',
		showDeleteConfirmationDialog: false,
		loadingStatus: '',
		alertComponentType: ALERT_TYPES.OK,
		errors: {},
		showAlert: false,
		alertMessage: "",
		redirect: false,
		showEmailAddressList: false,
		showPhoneNumberList: false
	}

	handleChange = (event) => {
		event.preventDefault();
		let targetValue = event.target.value;

		if (event.target.id && event.target.id.includes('emailEntry')) {
			const index = event.currentTarget.id.slice(-1);
			let alertEmailAddresses = this.state.alertEmailAddresses;
			alertEmailAddresses[index] = { id: index, value: targetValue, verified: alertEmailAddresses[index].verified, acknowledged: alertEmailAddresses[index].acknowledged, saved: false };
			this.setState({
				alertEmailAddresses,
				errors: {}
			});
		} else if (event.target.id && event.target.id.includes('phoneEntry')) {
			const index = event.currentTarget.id.slice(-1);
			let alertPhones = this.state.alertPhones;
			let value = formatPhone(targetValue, alertPhones[index].value);
			alertPhones[index] = { id: index, value, verified: alertPhones[index].verified, acknowledged: alertPhones[index].acknowledged, saved: false };
			this.setState({
				alertPhones,
				errors: {}
			});
		} else if (event.target.id && event.target.id.includes('emailAcknowledge')) {
			const index = event.currentTarget.id.slice(-1);
			let alertEmailAddresses = this.state.alertEmailAddresses;
			let acknowledged = alertEmailAddresses[index].acknowledged === true ? false : true;
			alertEmailAddresses[index] = { id: index, value: alertEmailAddresses[index].value, verified: alertEmailAddresses[index].verified, acknowledged, saved: false };
			this.setState({
				alertEmailAddresses,
				errors: {}
			});
		} else if (event.target.id && event.target.id.includes('phoneAcknowledge')) {
			const index = event.currentTarget.id.slice(-1);
			let alertPhones = this.state.alertPhones;
			let acknowledged = alertPhones[index].acknowledged === true ? false : true;
			alertPhones[index] = { id: index, value: alertPhones[index].value, verified: alertPhones[index].verified, acknowledged, saved: false };
			this.setState({
				alertPhones,
				errors: {}
			});
		} else {
			this.setState({
				[event.target.id]: targetValue ? targetValue : (event.target.type === 'number' ? 0 : targetValue),
				errors: {}
			})
		}
	}

	resendEmailVerification = (event) => {
		event.preventDefault();
		const index = event.target.id.slice(-1);
		let id = this.state.alertEmailAddresses[index].id;
		if (this.showLoading() === true) {
			let request = {
				id
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "userView/alertResendEmail", request, { withCredentials: true })
				.then((response) => {
					this.setState({ loadingStatus: "" }, this.showAlert(response.data.message));
				}, (error) => {
				});
		}
	}

	resendPhoneVerification = (event) => {
		event.preventDefault();
		const index = event.target.id.slice(-1);
		let id = this.state.alertPhones[index].id;
		if (this.showLoading() === true) {
			let request = {
				id
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "userView/alertResendPhone", request, { withCredentials: true })
				.then((response) => {
					this.setState({ loadingStatus: "" }, this.showAlert(response.data.message));
				}, (error) => {
				});
		}
	}

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	hideLoading = (loadingStatus) => {
		if (loadingStatus === 'ERROR') {
			this.setState({
				loadingStatus: ""
			})
		} else {
			this.setState({
				loadingStatus: ""
			})
		}
	}

	handleCancel = (event) => {
		event.preventDefault();
		this.props.history.push('/tenantAdmin/alerts');
	}

	handleSubmit = (event) => {
		event.preventDefault();
		const trimmedAlertFields = trimAlertFields(this.state);
		this.setState({ ...trimmedAlertFields },
			function () {
				this.validateAndSubmit();
			}
		)
	}

	handleSaveResult = (redirect, errorFound, message) => {
		let alertComponentType = errorFound ? 'WARNING' : '';
		this.setState({ loadingStatus: "", redirect, alertComponentType }, this.showAlert(message))
	}

	validateAndSubmit = () => {

		let errors = validateAlert(this.state, this.state.id === 0, this.props.multiTenantSettings.multiTenant === true);

		if (errors && Object.keys(errors).length > 0) {
			this.setState({ errors });
			return;
		}

		if (this.showLoading() === true) {
			let { alertComponentType, username, selectedEmailField, selectedPhoneField, showDeleteConfirmationDialog, loadingStatus, errors, showAlert, alertMessage, redirect, showEmailAddressList, showPhoneNumberList, ...request } = this.state; // remove UI only fields before submitting
			this.props.saveTenantAlert(request, this.handleSaveResult);
		}
	}

	// Delete methods
	handleDeleteAlert = () => {
		if (this.showLoading() === true) {
			let request = {
				alertId: this.state.id,
				filterText: this.props.alertListFilters.filterText,
				includeInactive:
					this.props.alertListFilters.includeInactive
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/alertDelete", request, { withCredentials: true })
				.then((response) => {
					this.setState({ loadingStatus: "", redirect: true }, this.showAlert(response.data.message));
				}, (error) => {

					this.setState({ loadingStatus: "", redirect: false }, this.showAlert(error.message));
				});
		}
	}

	showDeleteConfirmation = (event) => {
		event.preventDefault();
		this.setState({
			showDeleteConfirmationDialog: true
		})
	}

	hideDeleteConfirmation = () => {
		this.setState({
			showDeleteConfirmationDialog: false
		})
	}

	// Delete methods - End

	handleAddPhone = (event) => {
		if (event) {
			event.preventDefault();
		}
		let alertPhones = this.state.alertPhones;
		if (alertPhones.length >= this.props.alertSettings.numberOfPhones) {
			return;
		}
		alertPhones.push({ id: 0, value: '', verified: false, acknowledged: false, saved: false })
		this.setState({
			alertPhones
		})
	}

	handleDeletePhone = (event) => {
		event.preventDefault();

		const index = event.currentTarget.id.slice(-1);
		let alertPhones = this.state.alertPhones;
		alertPhones.splice(index, 1);

		this.setState({
			alertPhones
		});
	}

	handleAddEmail = (event) => {
		if (event) {
			event.preventDefault();
		}
		let alertEmailAddresses = this.state.alertEmailAddresses;
		if (alertEmailAddresses.length >= this.props.alertSettings.numberOfEmails) {
			return;
		}
		alertEmailAddresses.push({ id: 0, value: '', verified: false, acknowledged: false, saved: false })
		this.setState({
			alertEmailAddresses
		})
	}

	handleDeleteEmail = (event) => {
		event.preventDefault();

		const fieldNumber = event.currentTarget.id.slice(-1);
		let alertEmailAddresses = this.state.alertEmailAddresses;
		alertEmailAddresses.splice(fieldNumber, 1);

		this.setState({
			alertEmailAddresses
		});
	}

	handleEmailLookup = (event) => {
		event.preventDefault();

		const fieldNumber = event.currentTarget.id.slice(-1);
		if (!this.state.userId) {
			let errors = {};
			errors["userLookupButton"] = "Required.";
			errors["email" + fieldNumber] = "First select a User.";
			this.setState({
				errors
			})
			return;
		}

		this.setState({
			selectedEmailField: fieldNumber,
			showEmailAddressList: true
		});
	}

	handleCloseEmailLookup = (selectedId, selectedName) => {
		let index = this.state.selectedEmailField;
		index = parseInt(index);
		let alertEmailAddresses = this.state.alertEmailAddresses;
		alertEmailAddresses[index].id = selectedId;
		alertEmailAddresses[index].value = selectedName;
		this.setState({
			alertEmailAddresses,
			showEmailAddressList: false,
		})
	}

	handlePhoneLookup = (event) => {
		event.preventDefault();

		const fieldNumber = event.currentTarget.id.slice(-1);
		this.setState({
			selectedPhoneField: fieldNumber,
			showPhoneNumberList: true
		});
	}

	handleClosePhoneLookup = (selectedId, selectedName) => {
		let index = this.state.selectedPhoneField;
		index = parseInt(index);
		let alertPhones = this.state.alertPhones;
		alertPhones[index].id = selectedId;
		alertPhones[index].value = selectedName;
		this.setState({
			alertPhones,
			showPhoneNumberList: false,
		})
	}

	showAlert = (alertMessage) => {
		this.setState({
			showAlert: true,
			alertMessage
		})
	}

	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: '',
			alertComponentType: ''
		})

		if (this.state.redirect) {
			this.props.history.push('/tenantAdmin/alerts');
		}
	}

	componentDidMount() {
		this.props.setSelectedControlPanelType();
		
		axios.get(configData.LANDNOTIFICATION_SERVER_URL + "helperdata/multiTenantList", { withCredentials: true })
			.then(
				(response) => {
					const content = response.data.content;
					let codeDescriptionResultList = content.codeDescriptionResultList;
					this.setState({
						countyList: codeDescriptionResultList
					});
				},
				(error) => {
						alert("error");
					//   handleError(error, this.props.history);
				}
			);

		// new alert
		if (this.props.match.params.id === '0') {
			this.handleAddEmail();
			this.handleAddPhone();
			return;
		}

		axios.get(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/alert/" + this.props.match.params.id, { withCredentials: true })
			.then(
				(response) => {
					const content = response.data.content;
					let newState = this.getStateFromContent(content);
					this.setState(newState);
				},
				(error) => {
					console.log(error);
				}
			);
	}

	getStateFromContent = (content) => {
		return {
			id: content.id,
			userId: content.userId,
			savedUserId: content.userId,
			username: content.username,
			alertType: content.alertType,
			name: content.name,
			countyCode: content.countyCode,
			firstName: content.firstName,
			lastName: content.lastName,
			businessName: content.businessName,
			parcelId: content.parcelId,
			alertEmailAddresses: content.alertEmailAddresses,
			alertPhones: content.alertPhones,
			statusType: content.statusType
		};
	}

	render() {
		let disabledFlag = this.state.id !== 0;

		let alertTypeDescription = "Parcel ID";
		if (this.state.alertType === 'BUSINESS') {
			alertTypeDescription = "Business/Trust";
		} else if (this.state.alertType === 'NAME') {
			alertTypeDescription = "Person";
		}
		
		let pageButtons = [];
		pageButtons.push({ label: 'Delete', onClickAction: this.showDeleteConfirmation, className: 'btn btn-danger btn-sm' });

		let formTemplateMarginLeft = 60
		let formTemplateMarginRight = 20
		if (this.props.formOnly) {
			formTemplateMarginLeft = 0
			formTemplateMarginRight = 0
		} else if (this.props.sideNavigationOpen) {
			formTemplateMarginLeft = 270
		}

		let recipientsLabelStyle = { fontSize: '0.75em', marginLeft: 3 }
		if (this.state.errors['recipientsLabel'] === true) {
			recipientsLabelStyle = { fontSize: '1em', marginLeft: 3, color: "red", fontWeight: "bold" }
		} 

		return (
			<div style={{ marginLeft: formTemplateMarginLeft, marginRight: formTemplateMarginRight, marginTop: 4, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }}>
				<PageBanner pageHeading='Alert' buttons={this.state.id ? pageButtons : null} />
				<Container fluid="true" style={{ paddingLeft: 10, paddingBottom: 20, marginTop: 10, marginLeft: 4, marginRight: 4 }}>
					<Row>
						<Col>
							<Form onSubmit={this.handleSubmit}>
								<Form.Row>
									<Form.Group>
										<TextField formGroup={{ id: 'user', label: 'User', value: this.state.username, primaryCriteria: true, disableField: true }} />
									</Form.Group>
								</Form.Row>
								<Form.Row>
									<Form.Group >
										<TextField formGroup={{ id:'name', label: 'Alert Nickname', fieldType: 'text', value: this.state.name, required: true, primaryCriteria: true, hideRow: disabledFlag, disableField: true }} disabled={true} />
										<div style={{ fontSize: '0.75em', marginLeft: 3 }} >Give this alert a nickname to help you identify it.</div>
									</Form.Group>
								</Form.Row>
						
								<h5 style={{ textDecoration: 'underline' }}>Alert Criteria</h5>

								<Form.Row style={{ marginLeft: -1 }}>
									<Form.Group> <TextField formGroup={{ id: 'alertType', label: 'Monitor', fieldType: 'text', value: alertTypeDescription, primaryCriteria: true, disableField: true }}  /></Form.Group>
								</Form.Row>
								<Form.Row>
									{
										(this.state.alertType !== 'NAME') !== true &&
										<Form.Group controlId='firstName'>
											<TextField formGroup={{ label: 'First Name', fieldType: 'text', value: this.state.firstName, required: true, primaryCriteria: false }} onChange={this.handleChange} />
											<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['firstName']}</div>
										</Form.Group>
									}
									{
										(this.state.alertType !== 'NAME') !== true &&
										<Form.Group controlId='lastName'>
											<TextField formGroup={{ label: 'LAST Name', fieldType: 'text', value: this.state.lastName, required: true, primaryCriteria: true }} onChange={this.handleChange} />
											<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['lastName']}</div>
										</Form.Group>
									}
									{
										(this.state.alertType !== 'BUSINESS') !== true &&

										<Form.Group controlId='businessName'>
											<TextField formGroup={{ label: 'Business/Trust Name', fieldType: 'text', value: this.state.businessName, required: true, primaryCriteria: true }} onChange={this.handleChange} />
											<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['businessName']}</div>
										</Form.Group>
									}
									{
										(this.state.alertType !== 'PARCEL_ID') !== true &&
										<Form.Group controlId='parcelId'>
											<TextField formGroup={{ label: 'Parcel ID', fieldType: 'text', value: this.state.parcelId, required: true, primaryCriteria: true, hintLink: this.props.alertSettings.pidLink }} onChange={this.handleChange} />						
											<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['parcelId']}</div>
										</Form.Group>
									}
								</Form.Row>
								<h5 style={{ textDecoration: 'underline' }}>Alert Recipients</h5>
								<div style={recipientsLabelStyle} >Enter at least one Email or Text(SMS) Recipient.</div>
								<h6>Up to {this.props.alertSettings.numberOfEmails} Email Recipients</h6>
								<Row>
									<Col lg={9} md={9} sm={12} xs={12}>
										{
											this.state.alertEmailAddresses.map((emailAddress, index) => {
												return (
													<AlertEntryEmailRow id={index} key={emailAddress.id && emailAddress.id > 0 ? emailAddress.id : index} index={index} emailAddress={emailAddress} acknowledgement={this.props.alertSettings.emailAcknowledgement} errors={this.state.errors} onDelete={this.handleDeleteEmail} onChange={this.handleChange} onClick={this.handleEmailLookup} onResend={this.resendEmailVerification} ></AlertEntryEmailRow>
												)
											})
										}
									</Col>
								</Row>
								<Form.Row>
									{
										this.state.alertEmailAddresses.length < this.props.alertSettings.numberOfEmails &&
										<Button variant="link" id='addEmail' className='shadow-none' style={{ textDecoration: 'none' }} onClick={this.handleAddEmail}>{this.state.alertEmailAddresses.length === 0 ? '+ Add an email' : '+ Add another email'}</Button>											
									}
									{
										this.state.alertEmailAddresses.length >= this.props.alertSettings.numberOfEmails &&
										<>&nbsp;</>
									}
								</Form.Row>
								<h6>Up to {this.props.alertSettings.numberOfPhones} Text(SMS) Recipients</h6>
								<Row>
									<Col lg={9} md={9} sm={12} xs={12}>
										{
											this.state.alertPhones.map((phone, index) => {
												return (
													<AlertEntryPhoneRow id={index} key={phone.id && phone.id > 0 ? phone.id : index} index={index} phone={phone} acknowledgement={this.props.alertSettings.phoneAcknowledgement} errors={this.state.errors} onDelete={this.handleDeletePhone} onChange={this.handleChange} onClick={this.handlePhoneLookup} onResend={this.resendPhoneVerification} ></AlertEntryPhoneRow>
												)
											})
										}
									</Col>
								</Row>
								<Form.Row>
									{
										this.state.alertPhones.length < this.props.alertSettings.numberOfPhones &&
										<Button variant="link" id='addPhone' className='shadow-none' style={{ textDecoration: 'none' }} onClick={this.handleAddPhone}>{this.state.alertPhones.length === 0 ? '+ Add a phone' : '+ Add another phone'}</Button>
									}
									{
										this.state.alertPhones.length >= this.props.alertSettings.numberOfPhones &&
										<>&nbsp;</>
									}
								</Form.Row>
								<Row>&nbsp;</Row>
								<PrimaryButton buttonLabel="Done" disabled={this.state.status === LOADING_STATUES.LOADING} />&nbsp;&nbsp;
								{
									this.state.status === LOADING_STATUES.SUCCESS &&
									<span style={{ width: 18, verticalAlign: "bottom", paddingBottom: 1, display: "inline-block" }}>{checkIconGreen}</span>
								}
								{
									this.state.status === LOADING_STATUES.LOADING &&
									<span style={{ width: 18, verticalAlign: "bottom", marginBottom: 1, display: "inline-block" }}>{spinnerIconGray}</span>
								}

							</Form>
						</Col>
					</Row>
				</Container>
				<Alert type={this.state.alertComponentType} show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} />
				<Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
				<Confirmation show={this.state.showDeleteConfirmationDialog} cancelConfirmation={this.hideDeleteConfirmation} proceedConfirmation={this.handleDeleteAlert} question={'Delete Alert ?'} />
				<EmailAddressSelectionList showModal={this.state.showEmailAddressList} onHide={(selectedId, selectedName) => this.handleCloseEmailLookup(selectedId, selectedName)} />
				<PhoneNumberSelectionList showModal={this.state.showPhoneNumberList} onHide={(selectedId, selectedName) => this.handleClosePhoneLookup(selectedId, selectedName)} />
			</div>
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertEntry);
